import { render, staticRenderFns } from "./tableExpand.vue?vue&type=template&id=a88a8c3e&scoped=true"
import script from "./tableExpand.vue?vue&type=script&lang=js"
export * from "./tableExpand.vue?vue&type=script&lang=js"
import style0 from "./tableExpand.vue?vue&type=style&index=0&id=a88a8c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88a8c3e",
  null
  
)

export default component.exports